/* eslint-disable no-restricted-imports */
import React, {useEffect, useMemo, useState} from 'react'
import clsx from 'clsx'
import styles from './UIGameBeginnerHint.module.scss'
import {T, Tooltip} from '@colonist/ui'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {audioManager, Sound} from '../../../../../code/client/shared/scripts/Sound.ts'
import {getBeginnerHintContent} from './utils.ts'
import IconBeginnerHint from '@static/images/icon_beginner_hint.svg'
import {CardEnum} from '@colonist/game-states'
import {EnumUtils} from '@colonist/utils'

export interface UIGameBeginnerHintProps {
    className?: string | undefined
}

export const UIGameBeginnerHint = ({
    className,
}: UIGameBeginnerHintProps) => {
    const [isAnimationPlaying, setIsAnimationPlaying] = useState(true)
    const [position, setPosition] = useState<{x: number, y: number}>({x: 0, y: 0})
    const beginnerHintType = useGameStore((state) => state.gameBeginnerHint.beginnerHintType)
    const myColor = useGameStore((state) => state.myColor)

    const beginnerHintData = useGameStore((state) => state.gameBeginnerHint.beginnerHintData?.data)
    const wantedResources: CardEnum[] = beginnerHintData?.wantedResources != null ? beginnerHintData?.wantedResources : []
    const resourceName = wantedResources.length > 0 ? EnumUtils.getEnumKey(wantedResources[0], CardEnum) : ''
    const beginnerHintContent = useMemo(() => getBeginnerHintContent(beginnerHintType, myColor, resourceName),
        [beginnerHintType, myColor, resourceName])
    const shouldShowBeginnerHint = beginnerHintType != undefined

    const targetElement = beginnerHintContent ? document.getElementById(beginnerHintContent.elementId) : null
    useEffect(() => {
        if(beginnerHintContent != null && targetElement != null) {
            audioManager.play(Sound.SoundType.BeginnerHintActivated)
        } else {
            setIsAnimationPlaying(true)
        }
    }, [beginnerHintContent])

    const setContainerPosition = () => {
        if(targetElement) {
            const {x, y, width} = targetElement.getBoundingClientRect()
            const positionX = x + width / 2
            const positionY = y
            setPosition({x: positionX, y: positionY})
        }
    }

    useEffect(() => {
        setContainerPosition()
        window.addEventListener('resize', setContainerPosition)
        return () => {
            window.removeEventListener('resize', setContainerPosition)
        }
    }, [beginnerHintContent?.elementId])

    if(beginnerHintContent == null || targetElement == null || !shouldShowBeginnerHint) return null

    return <div className={clsx(className, styles.container)} style={{left: position.x, top: position.y}}>
        <Tooltip
            position="top"
            clickActionEnabled={true}
            content={<div className={styles.tooltipContent}>
                <img className={styles.hintTooltipIcon} src={beginnerHintContent.iconPath}/>
                <div className={styles.hintTooltipText}>
                    <div className={styles.hintTitle}>
                        <T id="strings:game.beginnerTips.actionHints.title"/>
                    </div>
                    <div className={styles.hintDescription}>
                        <T id={beginnerHintContent.description}/>
                    </div>
                </div>
            </div>}
            hoverActionEnabled={false}
            menuClassName={styles.hintTooltipMenu}
            onOpenChange={(tooltipOpen: boolean) => setIsAnimationPlaying(!tooltipOpen)}
        >
            <img className={clsx(styles.icon, {
                [styles.hintAnimation]: isAnimationPlaying,
            })} src={IconBeginnerHint}/>
        </Tooltip>
    </div>
}
